import { render, staticRenderFns } from "./BowReviews.vue?vue&type=template&id=8fd72874&"
import script from "./BowReviews.vue?vue&type=script&lang=js&"
export * from "./BowReviews.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {BowReview: require('/workspace/components/molecules/BowReviews/BowReview.vue').default,BowSlide: require('/workspace/components/molecules/BowSlider/BowSlide.vue').default,BowSlider: require('/workspace/components/molecules/BowSlider/BowSlider.vue').default})
